
export default {
  nameToColor(name) {
    const hash = [...Array(name.length).keys()].reduce(
      (h, i) => (name.charCodeAt(i) + ((h << 5) - h)), 0
    )
    let values = [0, 1, 2].map(
      n => ((hash >> (n * 8)) & 0xFF)
    )

    const ratios = values.map( v => (v / 0xFF) )
    const lightness = (Math.max(...ratios) + Math.min(...ratios)) / 2
    if(0.5 <= lightness){
      values = values.map( v => Math.floor(v * 0.49 / lightness) ) // darken
    }

    return `#${ values.map(v => (('00' + v.toString(16)).substr(-2))).join('') }`
  },
}